/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import './Chip.scss';
import { appChipStyle, appChipSize, getKeyByValue, appIconsPath } from '@utils/globalConstant';
import PropTypes from 'prop-types';
import { tA11y } from '@utils/a11y/a11yHelpers';
import { sanitizeRichText } from '@utils/sanitizeHtml';
import Icons from '@core/Utils/Icons/Icons';

export function Chip({
  chipStyle = appChipStyle.WHITE,
  chipSize = appChipSize.DEFAULT,
  icon = null,
  label = '',
  headingTag = 'h2'
}) {
  const iconHeight = chipSize === appChipSize.SMALL ? 12 : 16;
  const chipIcon = getKeyByValue(appIconsPath,icon);
  const HeadingTag = headingTag;  
  const customBgColor = chipStyle.startsWith('#') ? { backgroundColor: chipStyle } : {};
  const chipStyleClass = chipStyle.startsWith('#') ? '' : chipStyle; 

  return (
    <div
      className={`d-inline-block ${chipStyleClass} ${chipSize}`}
      style={{ ...customBgColor }}
    >
      <div className="d-flex align-items-center">
        {icon && (
          <Icons name={chipIcon}  className={`${
            chipStyle === appChipStyle.PRIMARY || chipStyle === appChipStyle.SUCCESS
              ? 'filter-ek-white'
              : 'filter-ek-primary'
          } pe-8`} height={iconHeight} alt="" colorType='dark' />
        )}
        {tA11y(label).isHtml ? (
          <HeadingTag
            className="pe-4 mb-0 ek-labeltext-12-medium"
            dangerouslySetInnerHTML={{ __html: sanitizeRichText(tA11y(label).content) }}
          />
        ) : (
          <HeadingTag className="pe-4 mb-0 ek-labeltext-12-medium">{tA11y(label).content}</HeadingTag>
        )}
      </div>
    </div>
  );
}

Chip.propTypes = {
  chipStyle: PropTypes.string,
  chipSize: PropTypes.string,
  icon: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired
};

export default Chip;
